'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import ProfilePicture from './ProfilePicture'
import { motion, AnimatePresence } from 'framer-motion'
import { FaChevronDown, FaUserShield, FaUser, FaCog, FaSignOutAlt, FaUserCog } from 'react-icons/fa'

export default function HeaderDropdown({ user, handleLogout }) {
    const [isOpen, setIsOpen] = useState(false)
    const router = useRouter()
    
    // Check if user has admin role
    const isAdmin = user?.user_metadata?.is_admin || false

    return (
        <div 
            className="relative justify-self-end" 
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <div className="flex items-center px-4 py-2 rounded-full hover:text-blue-500 transition-colors duration-200">
                <div className="flex items-center">
                    <ProfilePicture 
                        username={user.user_metadata.username} 
                        size={40}
                    />
                    <span className="text-white ml-[8px]">
                        {user.user_metadata.username}
                    </span>
                    <FaChevronDown className="ml-2 text-white transition-colors duration-200" />
                </div>
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.2 }}
                        className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 z-50"
                    >
                        
                        {(user.user_metadata.firstName || user.email) && (
                        <div className="greeting pr-5 text-xs text-gray-500 text-center font-medium">
                            Hello {user.user_metadata.firstName || user.username}!
                        </div>
                        )}
                        <button
                            onClick={() => {
                                router.push(`/${user.user_metadata.username}`)
                                setIsOpen(false)
                            }}
                            className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center"
                        >
                            <FaUser className="mr-2" />
                            My Profile
                        </button>
                        <button
                            onClick={() => {
                                router.push(`/${user.user_metadata.username}/dashboard`)
                                setIsOpen(false)
                            }}
                            className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center"
                        >
                            <FaUserCog className="mr-2" />
                            Account
                        </button>
                        <button
                            onClick={() => {
                                router.push(`/${user.user_metadata.username}/dashboard/settings`)
                                setIsOpen(false)
                            }}
                            className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center"
                        >
                            <FaCog className="mr-2" />
                            Settings
                        </button>
                        
                        {/* Admin Panel link - only shown for admin users */}
                        {isAdmin && (
                            <button
                                onClick={() => {
                                    router.push('/admin')
                                    setIsOpen(false)
                                }}
                                className="w-full text-left px-4 py-2 text-blue-600 hover:bg-gray-100 flex items-center"
                            >
                                <FaUserShield className="mr-2" />
                                Admin Panel
                            </button>
                        )}
                        
                        <hr className="border-gray-200 my-1" />
                        <button
                            onClick={() => {
                                handleLogout()
                                setIsOpen(false)
                            }}
                            className="w-full text-left px-4 py-2 text-red-600 hover:bg-gray-100 flex items-center"
                        >
                            <FaSignOutAlt className="mr-2" />
                            Logout
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}
